/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Cloud Upload",
  size: 20
}

const SvgCloudUpload = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.1}
      d="M6.5 14.61H3.75C1.96 14.61.5 13.17.5 11.39c0-1.63 1.22-2.98 2.81-3.19C3.38 5.31 5.75 3 8.68 3c2.51 0 4.63 1.71 5.21 4.02.5-.22 1.04-.34 1.61-.34 2.21 0 4 1.77 4 3.96s-1.79 3.96-4 3.96h-3"
    />
    <path fill="none" d="M7.25 11.75L9.5 9.5l2.25 2.25M9.5 18V9.5" />
  </Svg>
)

SvgCloudUpload.defaultProps = defaultProps
export default SvgCloudUpload
